
import { VTooltip } from 'floating-vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CPTooltipAdvanced extends Vue {

  @Prop({ required: false, default: 'up' })
  public direction!: string;

  @Prop({ required: false , default: 'up' })
  public tooltipPosition!: string;

  @Prop({ required: false, default: 'sm' })
  public size!: string;

  @Prop({ required: false, default: true })
  public trigger!: boolean;

  public visible: boolean = false;

  public show() { this.visible = true; }
  public hide() { this.visible = false; }

}
